import { Component, OnInit, ViewChild } from '@angular/core';
import { LazyLoadEvent, MessageService } from 'primeng/api';
import { takeUntil } from 'rxjs/operators';
import { AppMainService } from 'src/app/app-main.service';
import { SavedSearchNS } from '../../saved-searches/models/saved-search.models';
import { SavedSearchesService } from '../../saved-searches/services/saved-searches.service';
import { Subject } from 'rxjs/internal/Subject';
import { LocalDatePipe } from 'src/app/modules/shared/pipes/local-date.pipe';
import { ISavedSearchColumnModel, ISavedSearchFilterModel } from '../../saved-searches/models/saved-search-filter.model';
import * as moment from 'moment';
import { ParseHelper } from 'src/app/modules/shared/parse.helper';
import { MultiSelectFieldsNS } from '../../saved-searches/models/saved-search-multiselect-fields.static';
import { CdkDragDrop, CdkDragStart, moveItemInArray } from '@angular/cdk/drag-drop';
import { RatingValueObjects, SavedSearchMessage } from '../../saved-searches/models/saved-search.static';
import { ConfigurationService } from 'src/app/configurations/configurationService';
import { AccountModuleId } from 'src/app/modules/shared/constants/modules.constant';
import { AccountService } from 'src/app/accounts/accountService';
import { ObjectNames } from 'src/app/shared/constants';
import { AppMainComponent } from 'src/app/app.main.component';
import { DatePipe } from '@angular/common';
import { LeadService } from 'src/app/leads/leadService';
import { UserService } from 'src/app/service/userservice';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AddMassEdit } from '../Models/mass-edit.model';
import { CUSTOMFIELD_TYPE_IDS } from 'src/app/modules/shared/constants/typeId';
import { AppRuleSelectionService } from 'src/app/modules/shared/components/rule-selection/app.rule.selection.service';
import { AccountGroupId } from 'src/app/accounts/account.enum';

@Component({
  selector: 'app-add-edit-mass',
  templateUrl: './add-edit-mass.component.html',
  styleUrls: ['./add-edit-mass.component.scss'],
  providers: [LocalDatePipe]
})
export class AddEditMassComponent implements OnInit {

  protected ngUnsubscribe$: Subject<void> = new Subject<void>();
  @ViewChild('op', { static: false }) panel;

  displayAddEditMass = false;
  massHeader;
  methodOption=[];
  methodValue: string = "saveSearch";
  selectedSSName: string = 'Select a Save Search';
  allModules = [];
  selectedModule;
  allChannels = [];
  selectedChannel;
  columnSettingsConfig = [];
  allColumnSettings = [];
  settingObj: any;
  objectId;

  //account
  accountColumnSetting = [];
  pageNumber = 1;
  accountCols = [];
  accountListColsAll = [];
  rowGroupMetadata: any;
  expandedRows: any = [];
  allAccounts = [];
  accountsList = [];
  loading: boolean;
  noAccountFindOrLoadingText = 'Loading....';
  activeCustomFieldList = [];
  emailtype = []
  phonetype = []
  socialtype = []
  accountEmail = []
  accountPhone = []
  accountSocial = []
  selectedAccounts = [];
  accountColumnSettingsConfig: any;
  allAcountColumnSettings = [];
  accountSettings: any;
  accountObjId;
  activeAccountCols = [];

  //lead
  leadModuleConfig = [];
  leadEmail = []
  leadPhone = []
  leadSocial = []
  leadColumnSettingsConfig;
  leadAllColumnSettings;
  noLeadFindOrLoadingText = "Loading...";
  leadCols = [];
  leadListColsAll = [];
  leadSettings: any;
  currentPageNumber = 1;
  searchValueLead = "";
  allLeads = [];
  leadsData = [];
  leadObjId;
  activeLeadCols = [];

  savedSearchesList: SavedSearchNS.ISavedSearch[] = [];
  gridState: any = {};
  isActive: boolean = true;
  noSearchesFindOrLoadingText = 'No Saved Searches Found.';
  listCols: SavedSearchNS.IColumn[] = [
    { field: 'id', header: 'ID', show: false, value: '', checked: false, order: false, moveable: false, dataType: 'number' },
    { field: 'name', header: 'Name', objectNameList: 'name', show: true, value: '', checked: false, order: false, moveable: false, dataType: 'string' },
    { field: 'moduleName', header: 'Module', objectNameList: 'routeassignedto', show: true, value: '', checked: false, order: false, moveable: false, dataType: 'string' },
    { field: 'templateName', header: 'Template', objectNameList: 'totaldistance', show: true, value: '', checked: false, order: false, moveable: false, dataType: 'string' },
  ];
  selectedSearch;
  searchValueAccount: string = '';
  globalFilterInput = 'allterritorys';
  pageSize: number = 15;
  pageSize2: number = 15;
  pageSize3: number = 15;
  pageSize4: number = 15;
  tableShowMore: number[] = [15, 30, 50, 100];
  tableShowMore2: number[] = [15, 30, 50, 100];
  tableShowMore3: number[] = [15, 30, 50, 100];
  tableShowMore4: number[] = [15, 30, 50, 100];
  totalRecords: number = 0;
  totalRecords2: number = 0;
  totalRecords2Copy: number = 0;
  totalRecords3: number = 0;
  totalRecords4: number = 0;
  first: number = 0;
  first2: number = 0;
  first3: number = 0;
  first4: number = 0;

  layerNo = 1;
  totalAmt = 0;
  public dateCode: string = 'all';
  public dateFrom: any = new Date();
  public dateTo: any = new Date();

  //Restul List
  resultData = [];
  resultDataCopy = [];
  selectedResultFilters: ISavedSearchFilterModel[] = [];
  filterByInputValue = [];
  savedSearchStatus: boolean = true;
  savedSearchStatusCopy: boolean = true;
  savedSearchesName: string = null;
  savedSearchesId: number;
  accountChannelId: number;
  savedSearchesNote: string;
  pcalendarCustom: Date = new Date();
  ecalendarCustom: Date = new Date();
  selectedSavedSearch = [];

  //setting
  colSettingSearchInput: string = '';
  displayColSetting = false;
  startDrag = false;
  maxNo = false;
  displayMannuallySettings = false;

  selectedColumn;
  fieldGroup = [{}]
  saveSearchForm:FormGroup;
  constructor(
    private appMainService: AppMainService,
    private savedSearchesService: SavedSearchesService,
    public localDatePipe: LocalDatePipe,
    private messageService: MessageService,
    private configService: ConfigurationService,
    private accountService: AccountService,
    public app: AppMainComponent,
    public datePipe: DatePipe,
    private leadService: LeadService,
    public userService: UserService,
    private fb:FormBuilder,
    private ruleService: AppRuleSelectionService,
  ) { }

  ngOnInit(): void {
    this.createSaveSearchForm()
    this.getModuleDetails();
  }

  newMass(){
    this.massHeader = "Mass Edit";
    this.methodOption = [{label: 'Saved Search', value: 'saveSearch'}, {label: 'Manually', value: 'manually'}];

    this.displayAddEditMass = true;
    this.getUsers();
  }

  getSavedSearchListByFilter(event: LazyLoadEvent): void {
    if (!event.sortField && !event.filters) {
        if (event.first == 0 && event.rows == 15) {
            this.getSavedSeachList(1, 15);
            return;
        }
    }

    const pageSize: number = event.rows;
    const pageNumber: number = (event.first / event.rows) + 1;
    //if sort exist
    if (event.sortField) {
        const temp = {
            field: event.sortField,
            order: event.sortOrder
        }
        this.gridState['sort'] = temp;
    }
    //if column filter exist
    if (event.filters) {
        this.onFilterChange(event);
    }

    this.getSavedSeachList(pageNumber, pageSize);
  }
  onFilterChange(event: LazyLoadEvent): void {
    const filters = [];
    for (const filterName in event.filters) {
        filters.push({
            field: filterName,
            value: event.filters[filterName].value
        });
    }
    this.gridState['filters'] = filters
  }

  //SavedSearch Table List
  getSavedSeachList(pageNumber: number, pageSize: number): void {
    let searchValue = this.globalFilterInput.trim() ? this.globalFilterInput.trim() : '';
        const options: any = {};

        // apply field Filter
        if (this.gridState && this.gridState.filters && this.gridState.filters.length) {
            const filterColumns = [];
            this.gridState.filters.map(columnObj => {
                filterColumns.push(columnObj.field);
            });
            searchValue = this.gridState.filters && this.gridState.filters[0] && this.gridState.filters[0].value ? this.gridState.filters[0].value : '';
            options.filter = {
                field: filterColumns.join(','),
                value: searchValue
            }
        }

        // apply sorting
        if (this.gridState && this.gridState.sort) {
            options.sort = {
                SortBy: this.gridState.sort.field,
                IsAscending: this.gridState.sort.order === 1 ? true : false
            }
        }
      options.searchValueAccount = this.searchValueAccount.length ? this.searchValueAccount.trim() : '';

    this.appMainService.isShowSpinner('getSaveSearchList');
    this.savedSearchesService.getAllSavedSearchList(pageNumber, pageSize, this.isActive, options).pipe(takeUntil(this.ngUnsubscribe$)).subscribe((response) => {
        let data = response.body == null ? [] : response.body;
        let headers = JSON.parse(response.headers.get('X-Pagination'));
        headers = headers == null ? [] : headers;
        this.totalRecords = headers['TotalCount'] || 0;

        if (data.length == 0) {
            this.noSearchesFindOrLoadingText;
        }

        this.savedSearchesList = this.processSaveSearchData(data);
        this.appMainService.isHideSpinner('getSaveSearchList');
    },
        (error) => {
            this.appMainService.isHideSpinner('getSaveSearchList');
        });
  }
  //date convert
  processSaveSearchData(data: SavedSearchNS.ISavedSearch[]): any {
    return data.map((response) => {
        response.createdDate = this.localDatePipe.transform(response.createdDate, 'MM/DD/YYYY');
        const data = { ...response };
        return data;
    });
  }

  onRowSelect(e){
    this.selectedSSName = this.selectedSearch.name;
    this.panel.hide();
  }
  cancel(){
    this.selectedSearch = null;
    this.selectedSSName = 'Select a Save Search';
    this.selectedSavedSearch = [];
    this.layerNo = 1;
    this.selectedModule = null;
    this.selectedChannel = null;
    this.selectedColumn = null;
    this.displayAddEditMass = false;
  }
  showList(addEditType){
    this.layerNo = 2;
    if (this.selectedSearch) {
        this.appMainService.isShowSpinner('getSavedSearchById');
        this.savedSearchesService.getSavedSearchById(this.selectedSearch.id).pipe(takeUntil(this.ngUnsubscribe$)).subscribe((resp) => {
            this.appMainService.isHideSpinner('getSavedSearchById');
            // this.selectedSearch.savedSearchRuleRequest = resp.savedSearchRule;
            this.selectedSearch.savedSearchRuleRequest = this.getViewRuleRequest(resp.savedSearchRule);
            this.selectedSearch.savedSearchUserPermission = resp.savedSearchUserPermission;
            if (resp?.savedSearchColumnSetting?.find(x => x.statusId == 1)) {
                let selectedColums: SavedSearchNS.SavedSearchColumnSetting[] = JSON.parse(resp?.savedSearchColumnSetting?.find(x => x.statusId == 1)?.value ?? []);
                this.selectedSearch.savedSearchColumnSetting = selectedColums;
                this.calculateColumnSettingsMax();
                if (addEditType != 'None') {
                    //remove filter group
                    this.selectedSearch.columns = [];
                    setTimeout(() => {
                        this.selectedSearch.columns = this.getColumnSettingsForTable(selectedColums);
                    }, 0);
                }
            }
            if (addEditType == 'Select') {
            // this.onChangeRange({ dateFrom: this.dateFrom, dateTo: this.dateTo, code: this.dateCode, label: this.dateCode });
            this.filterByInputValue = [];
            this.resetResultPagination();
            this.getSavedSearchResultOnListIndex(1, this.pageSize2);


        }
        });

    }

    this.getSavedSearchResultOnListIndex(1, this.pageSize2);
  }
  resetResultPagination() {
    this.first2 = 0;
    this.first3 = 0;
  }
  getColumnSettingsForTable(selectedColums: SavedSearchNS.SavedSearchColumnSetting[]): any[] {
    this.selectedResultFilters = [];
    let columns: ISavedSearchColumnModel[] = [];
    if (selectedColums) {
        let i = 1;
        selectedColums?.map(f => {
            f?.fields?.filter(f => f.isSelected == true)?.map(x => {
                //nested field
                if (x?.nestedFields?.length > 0) {
                    x.nestedFields?.filter(n => n.isSelected == true)?.map(nestObj => {
                        columns.push(
                            {
                                id: i + 1,
                                field: nestObj.labelName,
                                header: nestObj.labelName,
                                fieldNameDB: nestObj.fieldName,
                                dataType: nestObj.fieldDataType == 'DateTime' ? 'date' : nestObj.fieldDataType == 'Number' && nestObj.fieldName != 'Qty'  ? 'number' :'string',
                                fieldDataType: nestObj.fieldDataType,
                                formControlType: nestObj?.formControlType,
                                isShow: nestObj.isSelected,
                                isCustom: x.isCustom
                            });
                        i = i + 1;
                    })
                }
                else {
                    columns.push(
                        {
                            id: i + 1,
                            field: x.labelName,
                            header: x.labelName,
                            fieldNameDB: x.fieldName,
                            dataType: x.fieldDataType == 'DateTime' ? 'date' : x.fieldDataType == 'Number' && x.fieldName != 'Qty' ? 'number' : 'string',
                            fieldDataType: x.fieldDataType as any,
                            formControlType: x?.formControlType,
                            isShow: x.isSelected,
                            isCustom: x.isCustom
                        });
                    i = i + 1;
                }
            });
        });
    }
    return columns;
  }
  getViewRuleRequest(savedSearchRule: any[]): SavedSearchNS.SavedSearchRuleRequest[] {
    let ruleRequest: SavedSearchNS.SavedSearchRuleRequest[] = [];
    if (savedSearchRule) {
        savedSearchRule.forEach(element => {
            if (element?.dataType == 'Enum') {
                if (element?.criteria?.toLowerCase() == 'territoryname') {
                    element.valuesJson = JSON.parse(element?.values[0]);
                }
            }
            else if (element?.dataType == 'Distance') {
                element.valuesJson = JSON.parse(element?.values[0]);
            }
            else {
                element.valuesJson = null;
            }
            ruleRequest.push(element);
        });
    }
    if (ruleRequest) {
        ruleRequest = ruleRequest.sort((a, b) => (a.sequenceOrder > b.sequenceOrder) ? 1 : -1);
    }
    return ruleRequest;
  }
  getSavedSearchResultByFilter(event: LazyLoadEvent): void {
    if (!event.sortField && !event.filters) {
        if (event.first == 0 && event.rows == 15) {
            this.getSavedSearchResultOnListIndex(1, 15);
            return;
        }
    }
    const pageSize: number = event.rows;
    const pageNumber: number = (event.first / event.rows) + 1;
    this.getSavedSearchResultOnListIndex(pageNumber, pageSize);
  }
  getSavedSearchResultOnListIndex(pageNumber: number, pageSize: number): void {
    const searchValue = this.prepareSearchResultValue();
    this.getSavedSearchResult(pageNumber, pageSize, this.selectedSearch.id, this.dateCode, this.dateFrom, this.dateTo, searchValue);
  }
  prepareSearchResultValue(): string {
    let savedSearchFilterSearchValueJson = null;
    if (this.selectedResultFilters?.length > 0) {
        const savedSearchFilterSearchValue = this.selectedResultFilters.map(x => ({ ColumnName: x.field, DataType: x.fieldDataType, IsCustom: x.isCustom, Value: x.value }));
        if (savedSearchFilterSearchValue) {
            savedSearchFilterSearchValueJson = JSON.stringify(savedSearchFilterSearchValue);
            savedSearchFilterSearchValueJson = encodeURIComponent(savedSearchFilterSearchValueJson);
        }
    }
    return savedSearchFilterSearchValueJson;
  }
  getSavedSearchResult(pageNumber: number, pageSize: number, savedSearchId: number, filter: string, fromdate: Date, todate: Date, searchValue: string) {
    this.appMainService.isShowSpinner('getSavedSearchResult');
    // this.resultData = [];
    this.savedSearchesService.getSavedSearchResult(pageNumber, pageSize, savedSearchId, filter, this.formatDate(fromdate, 'YYYY-MM-DD'), this.formatDate(todate, 'YYYY-MM-DD'), searchValue)
        .pipe(takeUntil(this.ngUnsubscribe$)).subscribe({
            next: (response) => {
                this.appMainService.isHideSpinner('getSavedSearchResult');
                let data = response.body == null ? [] : response.body;
                let headers = JSON.parse(response.headers.get('X-Pagination'));
                headers = headers == null ? [] : headers;
                this.totalRecords2 = headers['TotalCount'] || 0;
                this.totalRecords2Copy = this.totalRecords2;
                this.resultData = data?.Result ?? [];
                //copy the list data
                // this.resultDataCopy = ParseHelper.DeepCopy(this.resultData);
                //set filter value
                // this.setFilterValues(this.resultData);
            },
            error: (error) => {
                this.appMainService.isHideSpinner('getSavedSearchResult');
                this.totalRecords2 = 0;
                this.totalRecords2Copy = this.totalRecords2;
                this.resultData = [];
            }
        });
  }
  formatDate(date: Date, format: 'MM-DD-YYYY' | 'YYYY-MM-DD' = 'MM-DD-YYYY') {
    if (!date) {
        return null;
    }
    return moment(date).format(format);
  }

  onRemoveFilter(selectedFilters: ISavedSearchFilterModel[]): void {
    this.onApplyFilter(selectedFilters);
  }

  onOptionsFilter(event: { searchValue: string, selectedFilter: ISavedSearchFilterModel, selectedFilters: ISavedSearchFilterModel[] }): void {
      if (this.selectedSearch?.id && event?.selectedFilter) {
          if (event?.selectedFilter?.fieldDataType == 'DateTime' && event?.searchValue !== null) {
              if (moment(event.searchValue, "MM/DD/YYYY", true)?.isValid() == false) {
                  return;
              }
          }

        this.savedSearchesService.getSavedSearchFilter(this.selectedSearch.id, event.selectedFilter.field, event.selectedFilter.fieldDataType, event?.selectedFilter?.isCustom ?? false, event.searchValue)
        .pipe(takeUntil(this.ngUnsubscribe$)).subscribe({
            next: (response) => {
                // console.log(response)
                this.parseMultiSelectDataTypes(response);
            },
            error: (error) => {
            }
        });
      } else if(this.methodValue == 'manually' && this.selectedModule.name == 'Account'){
        // console.log(event?.selectedFilter)
        // console.log(this.accountsList)
        for(let s of this.accountsList){

        }
      }
  }
  parseMultiSelectDataTypes(listData: any[]): void {
    let filterByInputValue = ParseHelper.DeepCopy(listData);
    if (filterByInputValue?.length > 0) {
        for (const col of this.selectedSearch.columns) {
            if (MultiSelectFieldsNS.MultiSelectFieldsArray.includes(col.fieldNameDB?.toLowerCase())
                || MultiSelectFieldsNS.UserFieldsArray.includes(col.fieldNameDB?.toLowerCase())
                || col.isCustom == true
            ) {
                const oneTypeData = filterByInputValue.filter(obj => !obj[col.field]?.includes(','));
                const moreTypesData = filterByInputValue.filter(obj => obj[col.field]?.includes(','));
                filterByInputValue = [...oneTypeData];
                moreTypesData.map(moreTypes => {
                    const types = moreTypes[col.field].split(',');
                    types.map(splitType => {
                        moreTypes[col.field] = splitType.trim();
                        filterByInputValue.push(ParseHelper.DeepCopy(moreTypes));
                    })
                });
            }
        }
    }
    this.filterByInputValue = filterByInputValue;
  }
  //when apply any filter
  onApplyFilter(selectedFilters: ISavedSearchFilterModel[]): void {
      this.applyFilter(selectedFilters, 'apply');
  }
  //when Edit applied filter
  onModifyFilterOptions(selectedFilters: ISavedSearchFilterModel[]): void {
      this.applyFilter(selectedFilters, 'modify');
  }
  //Apply Filter logic
  private applyFilter(selectedFilters: ISavedSearchFilterModel[], applyType: 'apply' | 'modify') {
    if (applyType == 'apply') {
        this.selectedResultFilters = selectedFilters ?? [];
        this.resetResultPagination();
        this.getSavedSearchResultOnListIndex(1, this.pageSize2);
    }
  }

   //When date filter dropdown change
   onChangeRange(event: { dateFrom: any, dateTo: any, code: any, label: any }): void {
    this.dateCode = event.code.replaceAll(' ', '');
    this.dateFrom = event.dateFrom;
    this.dateTo = event.dateTo;
    this.resetResultPagination();
    this.getSavedSearchResultOnListIndex(1, this.pageSize2);
  }

  //setting
  showColumnSetting() {
    this.colSettingSearchInput = '';
    if(this.methodValue == 'saveSearch'){
        this.showList('None');
        this.displayColSetting = true;
    } else if(this.methodValue == 'manually' && this.selectedModule.name == 'Account'){
        this.columnSettingsConfig = this.accountColumnSettingsConfig;
        this.allColumnSettings = this.allAcountColumnSettings;
        this.settingObj = this.accountSettings;
        this.objectId = this.accountObjId;
        this.displayMannuallySettings = true;

    } else if(this.methodValue == 'manually' && this.selectedModule.name == 'Lead'){
        this.columnSettingsConfig = this.leadColumnSettingsConfig;
        this.allColumnSettings = this.leadAllColumnSettings;
        this.settingObj = this.leadSettings;
        this.objectId = this.leadObjId;
        this.displayMannuallySettings = true;

    }
  }
  dropListCol(event: CdkDragDrop<string[]>) {
    moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
  }
  cdkDragStarted(event: CdkDragStart) {
      this.startDrag = true;
  }

  cdkDragReleased() {
      this.startDrag = false;
  }
  toggleChilds(section: any) {
      section['hideChilds'] = !section?.hideChilds;
  }
  dropCol(event: CdkDragDrop<string[]>) {
      if (event.currentIndex > 1) {
          moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
      }
  }
   //Check/Uncheck Column Settings
   onCheckChange(isChecked: boolean, col: any, nestedCols: any) {
    if (isChecked) {
        if (this.totalAmt <= 12) {
            this.totalAmt++;
        }
        //select the parent column
        if (nestedCols && col) {
            col.isSelected = true;
        }
    }
    else {
        this.totalAmt--;
        //select/unselect the parent column
        if (nestedCols && col) {
            col.isSelected = nestedCols?.find(x => x?.isSelected == true) ? true : false;
        }
    }
    this.maxNo = this.totalAmt >= 12;
  }
  //Show/Hide nested columns
  showChild(col: any) {
      col.showChildrens = col?.showChildrens != undefined ? !col.showChildrens : true;
  }

  calculateColumnSettingsMax(): void {
      this.totalAmt = 0;
      for (let section of this.selectedSearch?.savedSearchColumnSetting) {
          this.totalAmt = this.totalAmt + section?.fields?.filter(x => x.isSelected == true && !(x.nestedFields?.length > 0))?.length ?? 0;
          this.totalAmt = this.totalAmt + section?.fields?.filter(x => x.nestedFields?.length > 0)?.filter(y => y.isSelected == true)?.length ?? 0;
      }
  }
  //Update Column Settings
  updateColumnSettings() {
    const columnSettignsObj: SavedSearchNS.IUpdateColumnSettings = {
        savedSearchId: this.selectedSearch.id,
        columns: JSON.stringify(this.selectedSearch?.savedSearchColumnSetting, null, null),
        updatedSource: 'string'
    };
    this.appMainService.isShowSpinner('updateColumnSettings');
    this.savedSearchesService.updateColumnSettings(columnSettignsObj)
        .pipe(takeUntil(this.ngUnsubscribe$)).subscribe((response) => {
            this.appMainService.isHideSpinner('updateColumnSettings');
            this.messageService.add({ severity: SavedSearchMessage.success.toLowerCase(), summary: SavedSearchMessage.success, detail: SavedSearchMessage.saveSearchaveColSettngSuccessMsg });
            this.displayColSetting = false;// close column settings
            this.resetFilterAndDate();
            this.showList('Select');
        },
            (error) => {
                this.appMainService.isHideSpinner('updateColumnSettings');
                this.messageService.add({ severity: SavedSearchMessage.error.toLowerCase(), summary: SavedSearchMessage.error, detail: SavedSearchMessage.saveSearchaveColSettngErrorMsg });
            });
  }
  resetFilterAndDate(){
    this.selectedResultFilters = [];
    this.dateCode = 'all';
    this.dateFrom = null;
    this.dateTo = null;
  }

  showChange(){
    this.layerNo = 3;
  }

  //mannually
  getModuleDetails() {
    this.allModules = [];
    this.configService.getModulesForQuestionnaire().subscribe(modules => {
        this.allModules = modules.filter(nm => nm.id == 1 || nm.id == 2);
    });
  }
  getChannelList(data) {
    this.configService.getConfigurationByModuleName('Lead').subscribe(configs => {

        let configJSONValueAccount = configs.filter(s => s.name == ObjectNames.ACCOUNT_CHANNEL && s.typeId == 97)[0]?.configurationDetails[0]?.configJSONValue;
        let configJSONValueLead = configs.filter(s => s.name == ObjectNames.LEAD_CHANNEL && s.typeId == 97)[0]?.configurationDetails[0]?.configJSONValue;

        const accountChannels = configJSONValueAccount ? JSON.parse(configJSONValueAccount) : [];
        const leadChannels = configJSONValueLead ? JSON.parse(configJSONValueLead) : [];

        if(data.name == 'Account') {
            this.allChannels = accountChannels.filter(el => el.isActive == true);
            this.selectedChannel = this.allChannels.find(el => el.isDefault == true);
         } else if (data.name == 'Lead') {
            this.allChannels = leadChannels.filter(el => el.isActive == true);
            this.selectedChannel = this.allChannels.find(el => el.isDefault == true);
         }
    });
  }
  getDataLists(){
    this.layerNo = 2;
    if(this.selectedModule.name == 'Account') {
        this.loadAccountConfigurations();
        this.loadAccountColumnSettings();
    } else if (this.selectedModule.name == 'Lead') {
        this.loadLeadConfigurations();
        this.loadLeadColumnSettings();
    }
  }
  //account
  loadAccountConfigurations() {
    this.appMainService.isShowSpinner('LoadAccountConfig')
    this.accountService.getAccountConfigurations().subscribe(configs => {
        this.appMainService.isHideSpinner('LoadAccountConfig')
        this.accountColumnSettingsConfig = configs.find(s => s.name == ObjectNames.ACCOUNT_COLUMN_SETTINGS && s.typeId == 105
            && s.configurationDetails && s.configurationDetails.find(obj => obj.levelRecordId == this.app.user.userId ||
                obj.levelRecordId === 0));

        this.allAcountColumnSettings = this.accountColumnSettingsConfig ? JSON.parse(this.accountColumnSettingsConfig.configurationDetails[0].configJSONValue) : [];

        //fields data
        this.emailtype = JSON.parse(configs.filter(s => s.name == ObjectNames.CONTACTS_EMAIL_TYPES)[0].configurationDetails.filter(c => c.statusId == 1)[0].configJSONValue);
        this.phonetype = JSON.parse(configs.filter(s => s.name == ObjectNames.CONTACTS_PHONE_TYPES)[0].configurationDetails.filter(c => c.statusId == 1)[0].configJSONValue);
        this.socialtype = JSON.parse(configs.filter(s => s.name == ObjectNames.CONTACTS_SOCIAL_TYPES)[0].configurationDetails.filter(c => c.statusId == 1)[0].configJSONValue);
        this.accountEmail = JSON.parse(configs.filter(s => s.name == ObjectNames.ACCOUNT_EMAIL_TYPES && s.typeId == 93)[0]?.configurationDetails[0].configJSONValue);
        this.accountPhone = JSON.parse(configs.filter(s => s.name == ObjectNames.ACCOUNT_PHONE_TYPES && s.typeId == 94)[0]?.configurationDetails[0].configJSONValue);
        this.accountSocial = JSON.parse(configs.filter(s => s.name == ObjectNames.ACCOUNT_SOCIAL_TYPES && s.typeId == 95)[0]?.configurationDetails[0].configJSONValue);
    },
        err => {
            this.appMainService.isHideSpinner('LoadAccountConfig')
        }
    )
  }
  getAccountsList(companyId: number, userId: number = 0, currentPageSize: number = 15, currentPageNumber: number = 1, src?, isLoadStage: boolean = true, isShowLoader: boolean = true) {
        const selectedRecent = 'allaccounts';
        let pageNumber = currentPageNumber ? currentPageNumber : 1;
        this.pageNumber = pageNumber;
        this.pageSize = currentPageSize;
        let searchValue = '';
        const options: any = {};
        options.isActive = this.isActive;
        options.searchValueAccount = this.searchValueAccount.length ? this.searchValueAccount.trim() : '';
        let visibleColumnsVales = '';

        this.accountService.getAllAccountBySearch(this.pageSize, this.pageNumber, companyId,
        this.app.user.userId, 0, selectedRecent, this.accountListColsAll, this.selectedChannel.id, 0,
        searchValue, visibleColumnsVales, options).then(responseData => {
            let { accounts, headers } = responseData;
            accounts = accounts == null ? [] : accounts;
            headers = headers == null ? [] : headers;
            this.totalRecords3 = headers['TotalCount'];
            this.loading = false;
            this.allAccounts = accounts;
            if (accounts) {
                let allAccounts = this.getAccountObj(accounts, true);
                this.accountsList = JSON.parse(JSON.stringify(allAccounts));
                this.updateRowGroupMetaData();
            }
        }).finally(() => {
            this.appMainService.isHideSpinner('getAllAccounts');
            this.noAccountFindOrLoadingText = 'No accounts found.';
        });
  }
  getAccountObj(accounts, fromList) {
    this.activeCustomFieldList = [];

    if (fromList) {
        this.accountCols.map(fieldObj => {
            if (fieldObj.custom == true && fieldObj.ischecked == true) {
                this.activeCustomFieldList.push(fieldObj)
            }
        });
    }

    return accounts.map((account) => {
        if (account.accountEmails && account.accountEmails.length) {
            const emailFieldData = account.accountEmails;
            emailFieldData.forEach(emailDataObj => {
                const dataField = this.accountEmail.find(emailtype => emailDataObj.email && emailDataObj.email.emailTypeId && emailtype.id == emailDataObj.email.emailTypeId)
                if (dataField) {
                    account[dataField.code] = (emailDataObj.email && emailDataObj.email.emailAddress) ? emailDataObj.email.emailAddress :
                        emailDataObj.emailAddress ? emailDataObj.emailAddress : '';
                }
            });
        }

        if (account.accountPhones && account.accountPhones.length) {
            const emailFieldData = account.accountPhones;
            emailFieldData.forEach(phoneDataObj => {
                const dataField = this.accountPhone.find(phoneltype => phoneDataObj.phone && phoneDataObj.phone.phoneTypeId && phoneltype.id == phoneDataObj.phone.phoneTypeId)
                if (dataField) {
                    account[dataField.code] = (phoneDataObj.phone && phoneDataObj.phone.number) ? phoneDataObj.phone.number :
                        phoneDataObj.phoneNumber ? phoneDataObj.phoneNumber : '';
                }
            });
        }

        if (account.accountSocials && account.accountSocials.length) {
            const emailFieldData = account.accountSocials;
            emailFieldData.forEach(socialDataObj => {
                const dataField = this.accountSocial.find(socialType => socialDataObj.socialProfile && socialDataObj.socialProfile.socialProfileTypeId && socialType.id == socialDataObj.socialProfile.socialProfileTypeId)
                if (dataField) {
                    account[dataField.code] = socialDataObj.socialProfile.name
                }
            });
        }

        if (account.accountContacts && account.accountContacts.length > 0) {
            let contact = account.accountContacts.find(x => x.contact && x.contact.isPrimaryContact)?.contact;
            if (contact) {
                if (contact.contactEmails && contact.contactEmails.length) {
                    const emailFieldData = contact.contactEmails;
                    emailFieldData.forEach(emailDataObj => {
                        const dataField = this.emailtype.find(emailtype => emailDataObj.email && emailDataObj.email.emailTypeId
                            && emailtype.id == emailDataObj.email.emailTypeId)
                        if (dataField) {
                            account['contactemail' + dataField.code] = (emailDataObj.email && emailDataObj.email.emailAddress) ?
                            emailDataObj.email.emailAddress :
                                emailDataObj.emailAddress ? emailDataObj.emailAddress : '';
                        }
                    });
                }

                if (contact.contactPhones && contact.contactPhones.length) {
                    const phoneFieldData = contact.contactPhones;
                    phoneFieldData.forEach(phoneDataObj => {
                        const dataField = this.phonetype.find(phoneltype => phoneDataObj.phone && phoneDataObj.phone.phoneTypeId && phoneltype.id == phoneDataObj.phone.phoneTypeId)
                        if (dataField) {
                            account['contactphone' + dataField.code] = (phoneDataObj.phone && phoneDataObj.phone.number) ? phoneDataObj.phone.number :
                                phoneDataObj.phoneNumber ? phoneDataObj.phoneNumber : '';
                        }
                    });
                }

                if (contact.contactSocialProfiles && contact.contactSocialProfiles.length) {
                    const socialFieldData = contact.contactSocialProfiles;
                    socialFieldData.forEach(socialDataObj => {
                        const dataField = this.socialtype.find(socialType => socialDataObj.socialProfile && socialDataObj.socialProfile.socialProfileTypeId && socialType.id == socialDataObj.socialProfile.socialProfileTypeId)
                        if (dataField) {
                            account['contactsocial' + dataField.code] = socialDataObj.socialProfile.name;
                        }
                    });
                }
            }
        }

        if (this.activeCustomFieldList.length) {
            this.activeCustomFieldList.map((customField) => {
                const newVal = this.getCustomFieldValue(customField, account.customAttributeValues)
                account[customField.field] = newVal;
            })
        }

        account['address'] = (account['city'] ? account['city'] + ', ' : '')
            + (account['state'] ? account['state'] + ', ' : '')
            + (account['country'] ? account['country'] + ', ' : '')
            + (account['zipcode'] ? account['zipcode'] : '');

        // Format Account Types
        let typeNames: string = account.accountTypesName;

        if (typeNames) {
            typeNames = typeNames.trim();
            typeNames = typeNames.endsWith(',') ? typeNames.substring(0, typeNames.length - 1) : typeNames;
            account.accountTypesName = typeNames;
        }

        // Format Job Function
        let jobFunction: string = account.jobFunction;

        if (jobFunction) {
            jobFunction = jobFunction.trim();
            jobFunction = jobFunction.endsWith(',') ? jobFunction.substring(0, jobFunction.length - 1) : jobFunction;
            account.jobFunction = jobFunction;
        }

        const data = {
            ...account,
        }
        data['createdDate'] = data['createdDate'] ? this.localDatePipe.transform(data['createdDate'], 'date') : null;
        data['updatedDate'] = data['updatedDate'] ? this.localDatePipe.transform(data['updatedDate'], 'date') : null;
        return data;
    })

    function getPhone(_account) {
        if (!_account.accountContacts) {
            return null;
        }

        return _account.accountContacts.reduce((phone, data) => {
            return [...phone, ...data.contact.contactPhones.map(({ phone: { number } }) => number)]
        }, [])
    }
}
  onExpandRow(parentId, parent, expanded) {
    //expanded = !expanded;
    parent.viewDetails = !expanded;
    this.expandedRows[parentId] = !expanded;

    if (!(parent.childAccount && parent.childAccount.length > 0)) {
        const options: any = {};
        let visibleColumnsVales = '';
        const selectedRecent = 'allaccounts';
        options.isActive = this.isActive;
        this.appMainService.isShowSpinner('getAllAccounts');
        this.accountService.getAllAccountBySearch(0, 0, this.app.user.companyId, this.app.user.userId, parentId, selectedRecent, this.accountCols, this.selectedChannel.id, 0, '', visibleColumnsVales, options).then(responseData => {
            let { accounts, headers } = responseData;
            accounts = accounts == null ? [] : accounts;
            headers = headers == null ? [] : headers;
            if (accounts) {
                let allAccounts = this.getAccountObj(accounts, true);
                parent.childAccount = allAccounts;
                parent.viewDetails = true;
                this.expandedRows[parentId] = true;
                this.getExoandedRows(parent.childAccount)
            }
        }).finally(() => {
            this.appMainService.isHideSpinner('getAllAccounts');
            this.noAccountFindOrLoadingText = 'No accounts found.';
        });
    }
  }
  getCustomFieldValue(customFieldName, customAttributeValues) {
    let value: any = '';
    if (customAttributeValues && customAttributeValues.length) {

        const matchedValue = customAttributeValues.find(customAttributeValue => customAttributeValue.customAttribute.fieldName == customFieldName.name);
        if (matchedValue) {
            switch (matchedValue.customAttribute.formControlId) {
                case 1: // DropdownList
                    value = matchedValue.value ? JSON.parse(matchedValue.value).name : null;
                    break;
                case 2: // Checkbox
                    value = matchedValue.value ? JSON.parse(matchedValue.value).join() : null;
                    break;
                case 3: // Radio
                    value = matchedValue.value ? matchedValue.value : null;
                    break;
                case 4: // Toggle
                    value = matchedValue.value;
                    break;
                case 7: // Rating
                    value = matchedValue.value;
                    break;
                case 8: // Input
                    value = matchedValue.value;
                    break;
                case 9: // 9 = datepicker
                    value = matchedValue.value ? this.datePipe.transform(matchedValue.value, 'dd/MM/yy') : '';
                    break;
                case 11: // MultipleDropDownList
                    const arrVal = matchedValue.value ? JSON.parse(matchedValue.value) : [];
                    if (arrVal.length) {
                        value = arrVal.map(val => val.name).join(', ')
                    } else {
                        value = '';
                    }
                    break;
            }

        }

    }
    return value;
  }
  updateRowGroupMetaData() {
    this.rowGroupMetadata = [];
    this.getExoandedRows(this.accountsList, 'main');
    this.rowGroupMetadata = this.accountsList;
  }
  getExoandedRows(list, main?) {
    list.forEach(element => {
        element.viewDetails = main == 'main' ? true : false;
        if (element.hasChildAccounts) {
            this.expandedRows[element.id] = false;
        }
    });
  }
  loadAccountColumnSettings(fromUpdateSettings = false) {
    this.app.appMainService.isShowSpinner('loaAccountColumnSettings')
    this.accountObjId = this.app.preLoadedObjects.find(el => el.name == 'Account')?.id;
    this.accountService.getAccountColumnsSetings(this.selectedChannel.id, this.accountObjId).subscribe(
        resp => {
            this.app.appMainService.isHideSpinner('loaAccountColumnSettings')
            this.accountSettings = resp;

            if (!this.accountSettings || this.accountSettings.listCols == null || this.accountSettings.listCols == undefined) {
                this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Column Settings Data not found...' });
                return;
            }

            this.accountSettings.listCols.map(obj => {
                obj.value = '';
            })
            this.app.appMainService.isHideSpinner('loaAccountColumnSettings')
            this.setAccountColoumSettings(fromUpdateSettings);


            if (fromUpdateSettings) {
                this.getAccountsList(this.app.user.organizationId, 15, this.pageSize, 1, null, false);
            }
        },
        err => {
            this.app.appMainService.isHideSpinner('loaAccountColumnSettings')
        }
    );
  }
  setAccountColoumSettings(fromUpdateSettings = false) {
    this.accountCols = this.accountSettings ? this.getFlatCols(this.accountSettings.listCols) : this.accountCols;
    this.accountListColsAll = this.accountCols;
    if (fromUpdateSettings) {
        this.accountCols = this.accountListColsAll;
    }
    const cols = this.accountCols.filter(ele => ele.ischecked);
    let arr = [];
    for(let s of cols){
        let eachCol = {
            id:s.id,
            field:s.labelname,
            dataType:s.fieldDataType,
            fieldDataType:s.fieldDataType,
            fieldNameDB:s.labelname,
            header:s.labelname,
        }
        arr.push(eachCol)
    }
    this.activeAccountCols = JSON.parse(JSON.stringify(arr));
  }
  getFlatCols(colArr) {
    let fieldArr = [];
    colArr.forEach(element => {
        element.fields.forEach(field => {
            if (field.fieldTypes && field.fieldTypes.fields) {
                fieldArr = [...fieldArr, ...field.fieldTypes.fields];
            }
            fieldArr.push(field);
        });
    });
    return fieldArr;
  }
  async getAllAcountsWithPagination(event: LazyLoadEvent) {
    const size = event.rows;
    const pageNumber: number = (event.first / event.rows) + 1;
    let userId = 0;
    if (event.sortField) {
        const temp = {
            field: event.sortField,
            order: event.sortOrder
        }
        this.gridState['sort'] = temp;
    }
    this.getAccountsList(this.app.user.organizationId, userId, size, pageNumber, null, false);
  }
  //lead
  loadLeadConfigurations() {
    this.appMainService.isShowSpinner('getConfigs');
    this.configService.getConfigurationByModuleName('Lead').subscribe(configs => {
        this.appMainService.isHideSpinner('getConfigs');

        this.leadEmail = JSON.parse(configs.filter(s => s.name == ObjectNames.LEAD_EMAIL_TYPES && s.typeId == 93)[0].configurationDetails[0].configJSONValue);
        this.leadPhone = JSON.parse(configs.filter(s => s.name == ObjectNames.LEAD_PHONE_TYPES && s.typeId == 94)[0].configurationDetails[0].configJSONValue);
        this.leadSocial = JSON.parse(configs.filter(s => s.name == ObjectNames.LEAD_SOCIAL_TYPES && s.typeId == 95)[0].configurationDetails[0].configJSONValue);

        this.leadColumnSettingsConfig = configs.find(s => s.name == ObjectNames.LEAD_COLUMN_SETTINGS && s.typeId == 105 &&
            s.configurationDetails && s.configurationDetails.find(obj => obj.levelRecordId == this.app.user.userId
                || obj.levelRecordId === 0));
        this.leadAllColumnSettings = this.leadColumnSettingsConfig ? JSON.parse(this.leadColumnSettingsConfig.configurationDetails[0].configJSONValue) : null;

        this.emailtype = JSON.parse(configs.filter(s => s.name == ObjectNames.CONTACTS_EMAIL_TYPES)[0].configurationDetails.filter(c => c.statusId == 1)[0].configJSONValue);
        this.phonetype = JSON.parse(configs.filter(s => s.name == ObjectNames.CONTACTS_PHONE_TYPES)[0].configurationDetails.filter(c => c.statusId == 1)[0].configJSONValue);
        this.socialtype = JSON.parse(configs.filter(s => s.name == ObjectNames.CONTACTS_SOCIAL_TYPES)[0].configurationDetails.filter(c => c.statusId == 1)[0].configJSONValue);

        this.emailtype = this.emailtype || [];
        this.emailtype = this.emailtype || [];
        this.socialtype = this.socialtype || [];
    },
        () => {
            this.appMainService.isHideSpinner('getConfigs');
        });
  }
  loadLeadColumnSettings() {
    this.app.appMainService.isShowSpinner('loadLeadColumnSettings')
    this.leadObjId = this.app.preLoadedObjects.find(el => el.name == 'Lead')?.id;
    this.accountService.getAccountColumnsSetings(this.selectedChannel?.id, this.leadObjId).subscribe(
        resp => {
            this.app.appMainService.isHideSpinner('loadLeadColumnSettings')
            this.leadSettings = resp;

            if (!this.leadSettings || this.leadSettings.listCols == null || this.leadSettings.listCols == undefined) {
                this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Column Settings Data not found...' });
                return;
            }

            this.leadSettings.listCols.map(obj => {
                obj.value = '';
            });
            this.setLeadColoumSettings();
        },
        () => {
            this.app.appMainService.isHideSpinner('loadLeadColumnSettings')
        }
    );
  }

  setLeadColoumSettings() {
    this.leadCols = this.leadSettings ? this.getFlatCols(this.leadSettings.listCols) : this.leadCols;
    this.leadListColsAll = JSON.parse(JSON.stringify(this.leadCols));
    this.leadCols = this.leadListColsAll;

    const cols = this.leadCols.filter(ele => ele.ischecked);
    let arr = [];
    for(let s of cols){
        let eachCol = {
            id:s.id,
            field:s.labelname,
            dataType:s.fieldDataType,
            fieldDataType:s.fieldDataType,
            fieldNameDB:s.labelname,
            header:s.labelname,
        }
        arr.push(eachCol)
    }
    this.activeLeadCols = JSON.parse(JSON.stringify(arr));
  }
  getAllLeadsWithPagination(event: LazyLoadEvent) {
    const size = event.rows;
    const pageNumber: number = (event.first / event.rows) + 1;
    let userId = 0;
    if (event.sortField) {
        const temp = {
            field: event.sortField,
            order: event.sortOrder
        }
        this.gridState['sort'] = temp;
    }

    if (event.filters != null) {
        this.onFilterChange(event);
    }
    this.getLeadsList(this.app.user.organizationId, userId, size, pageNumber, 0, true, false);
  }
  getLeadsList(companyId: number, userId: number = 0, currentPageSize: number = this.pageSize, currentPageNumber: number = 1, leadStageId: number = 0, isShowLoader = true, isCallCount = true) {
    let gridSearchValue = '';
    let pageNumber = currentPageNumber ? currentPageNumber : 1;
    this.currentPageNumber = pageNumber;
    this.pageSize = currentPageSize;
    let visibleColumnsVales = '';
    const options: any = {};
    options.moduleSearchValue = this.searchValueLead.length ? this.searchValueLead.trim() : '';
    isShowLoader && this.appMainService.isShowSpinner('getAllLeads');
    let objectNamesList = [];
    let stageId = 0;

    this.leadService.getAllLeads(this.pageSize, pageNumber, companyId, this.app.user.userId, this.isActive, gridSearchValue,
        visibleColumnsVales, stageId, options, this.selectedChannel['id'], objectNamesList)
        .then((responseData) => {
            let { leads, headers } = responseData;
            leads = leads == null ? [] : leads;
            if (leads.length === 0) {
                this.noLeadFindOrLoadingText = 'No Leads Available';
            } else {
                this.noLeadFindOrLoadingText = '';
            }
            this.loading = false;
            headers = headers == null ? [] : headers;
            this.totalRecords4 = headers['TotalCount'];
            this.allLeads = JSON.parse(JSON.stringify(leads));
            let leadDatas = this.getLeadObj(leads, this.leadCols);
            this.leadsData = leadDatas;

        }).finally(() => {
            isShowLoader && this.appMainService.isHideSpinner('getAllLeads');
            this.noLeadFindOrLoadingText = "No leads found.";
        });
  }
  getLeadObj(leads, leadCols) {
    let activeCustomFieldList :any[]=[];
    leadCols.map(fieldObj => {
        if (fieldObj.custom == true && fieldObj.ischecked == true) {
            activeCustomFieldList.push(fieldObj)
        }
    });

    return leads.map((lead) => {
        if (lead.leadEmails && lead.leadEmails.length) {
            const emailFieldData = lead.leadEmails;
            emailFieldData.forEach(emailDataObj => {
                const dataField = this.leadEmail.find(emailtype => emailDataObj.email && emailDataObj.email.emailTypeId && emailtype.id == emailDataObj.email.emailTypeId)
                if (dataField) {
                    lead[dataField.code] = (emailDataObj.email && emailDataObj.email.emailAddress) ? emailDataObj.email.emailAddress :
                        emailDataObj.emailAddress ? emailDataObj.emailAddress : '';
                }
            });
        }

        if (lead.leadPhones && lead.leadPhones.length) {
            const phoneFieldData = lead.leadPhones;
            phoneFieldData.forEach(phoneDataObj => {
                const dataField = this.leadPhone.find(phoneltype => phoneDataObj.phone && phoneDataObj.phone.phoneTypeId && phoneltype.id == phoneDataObj.phone.phoneTypeId)
                if (dataField) {
                    lead[dataField.code] = (phoneDataObj.phone && phoneDataObj.phone.number) ? phoneDataObj.phone.number :
                        phoneDataObj.phoneNumber ? phoneDataObj.phoneNumber : '';
                }
            });
        }

        if (lead.leadSocials && lead.leadSocials.length) {
            const socialFieldData = lead.leadSocials;
            socialFieldData.forEach(socialDataObj => {
                const dataField = this.leadSocial.find(socialType => socialDataObj.socialProfile && socialDataObj.socialProfile.socialProfileTypeId && socialType.id == socialDataObj.socialProfile.socialProfileTypeId)
                if (dataField) {
                    lead[dataField.code] = socialDataObj.socialProfile.name;
                }
            });
        }

        if (lead.leadContacts && lead.leadContacts.length > 0) {
            let contact = lead.leadContacts.find(x => x.contact && x.contact.isPrimaryContact)?.contact;
            if (contact) {
                if (contact.contactEmails && contact.contactEmails.length) {
                    const emailFieldData = contact.contactEmails;
                    emailFieldData.forEach(emailDataObj => {
                        const dataField = this.emailtype.find(emailtype => emailDataObj.email && emailDataObj.email.emailTypeId && emailtype.id == emailDataObj.email.emailTypeId)
                        if (dataField) {
                            lead['contactemail' + dataField.code] = (emailDataObj.email && emailDataObj.email.emailAddress) ? emailDataObj.email.emailAddress :
                                emailDataObj.emailAddress ? emailDataObj.emailAddress : '';
                        }
                    });
                }

                if (contact.contactPhones && contact.contactPhones.length) {
                    const phoneFieldData = contact.contactPhones;
                    phoneFieldData.forEach(phoneDataObj => {
                        const dataField = this.phonetype.find(phoneltype => phoneDataObj.phone && phoneDataObj.phone.phoneTypeId && phoneltype.id == phoneDataObj.phone.phoneTypeId)
                        if (dataField) {
                            lead['contactphone' + dataField.code] = (phoneDataObj.phone && phoneDataObj.phone.number) ? phoneDataObj.phone.number :
                                phoneDataObj.phoneNumber ? phoneDataObj.phoneNumber : '';
                        }
                    });
                }

                if (contact.contactSocialProfiles && contact.contactSocialProfiles.length) {
                    const socialFieldData = contact.contactSocialProfiles;
                    socialFieldData.forEach(socialDataObj => {
                        const dataField = this.socialtype.find(socialType => socialDataObj.socialProfile && socialDataObj.socialProfile.socialProfileTypeId && socialType.id == socialDataObj.socialProfile.socialProfileTypeId)
                        if (dataField) {
                            lead['contactsocial' + dataField.code] = socialDataObj.socialProfile.name;
                        }
                    });
                }
            }
        }

        if (activeCustomFieldList.length) {
            activeCustomFieldList.map((customField) => {
                const newVal = this.getCustomFieldValue(customField, lead.customAttributeValues)
                lead[customField.field] = newVal;
            })
        }

        lead['address'] = (lead['city'] ? lead['city'] + ', ' : '')
            + (lead['state'] ? lead['state'] + ', ' : '')
            + (lead['country'] ? lead['country'] + ', ' : '')
            + (lead['zipcode'] ? lead['zipcode'] : '');

        // Format Lead Types
        let typeNames: string = lead.leadTypesName;

        if (typeNames) {
            typeNames = typeNames.trim();
            typeNames = typeNames.endsWith(',') ? typeNames.substring(0, typeNames.length - 1) : typeNames;
            lead.leadTypesName = typeNames;
        }

        // Format Job Function
        let jobFunction: string = lead.jobFunction;

        if (jobFunction) {
            jobFunction = jobFunction.trim();
            jobFunction = jobFunction.endsWith(',') ? jobFunction.substring(0, jobFunction.length - 1) : jobFunction;
            lead.jobFunction = jobFunction;
        }

        const data = {
            ...lead,
        }
        // data['createdDate'] = data['createdDate'] ? this.localDatePipe.transform(data['createdDate'], 'date') : null;
        // data['updatedDate'] = data['updatedDate'] ? this.localDatePipe.transform(data['updatedDate'], 'date') : null;
        data.leadStatus = data.leadStatus?.name;
        data.discription = data.description;
        return data;
    })
  }

  //mannully setting
  onUpdateSetting(settingData) {
    this.displayMannuallySettings = false;
    if(this.selectedModule.name == 'Account'){
        this.accountSettings = settingData;
        this.loadAccountColumnSettings(true);
    } else if(this.selectedModule.name == 'Lead') {
        this.leadSettings = settingData;
        this.loadLeadColumnSettings();
    }

  }
  onUpdateProcess(progressStatus) {
    if (progressStatus.start) {
        this.appMainService.isShowSpinner('UpdatingSetting')
    } else {
        this.appMainService.isHideSpinner('UpdatingSetting')
    }
  }
  settingCancelClicked(event) {
    this.displayMannuallySettings = false;
  }

  //field group
  addFieldGroup(){
    this.fieldGroup.push({})
  }
  removeFieldGroup(i){
    this.fieldGroup.splice(i,1);
  }

  users:any = [];
  selectedUser:any;
  getUsers(){
    this.userService.getUsers(this.app.companyId).then(users => {
      if (users && users.length) {
          this.users = users.sort((a, b) => a.name.localeCompare(b.name)).filter(user => user.statusId == 1);
          this.selectedUser = this.users.filter(user => user.id == this.app.user.userId);
      }
    });
  }

  createSaveSearchForm(){
    this.saveSearchForm = this.fb.group({
        // selectedSearch:[this.selectedSearch,[Validators.required],[]],
        name:[null,[Validators.required]],
        accessPermission:[null,[Validators.required]],
        module:[null,[Validators.required]],
        channel:[null,[Validators.required]]
    })
  }
}

